export default {
  loading: 'Loading',
}
